import { FormCreateResponseApi } from '../types/formCreateApi';

export interface UpdateFormResponse {
  formVersion: number;
  publicUrl: string;
  sourceTrackingEnabled: boolean;
}

export const mapUpdateFormResponse = (
  response: FormCreateResponseApi
): UpdateFormResponse => ({
  formVersion: response.version,
  publicUrl: response.form_link,
  sourceTrackingEnabled: response.is_source_tracking_enabled
});

export default mapUpdateFormResponse;
